var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',[_c('router-view')],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"mt-2":""}}),_vm._v(" "),_c('v-footer',{attrs:{"color":"secondary lighten-1"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",staticStyle:{"margin-bottom":"2px"},attrs:{"flat":"","small":""},on:{"click":_vm.goHomepage}},[_vm._v("donnert")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87faa210","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 